/*----- Core -----*/
import React		 from 'react'
import styled		 from 'styled-components'
import PropTypes from 'prop-types'

/*----- Commons -----*/
import Montserrat from '../../commons/mixins/fonts/Montserrat'
import Device		  from '../../commons/Device'
import Color 			from '../../commons/Color'

/*----- Styles-----*/
const StyledInsuranceItem = styled.article`
	display: flex;
	margin: 32px 0;

	.hero-paragraph__text-container {
		position: relative;
		z-index: 1;
		max-width: 500px;
	}
	.hero-paragraph__title {
		${ Montserrat(32, 600, Color.main ) };
		line-height: 32px;
		margin: 0;
	}
	.hero-paragraph__border {
		width: 140px;
		height: 10px;
		background-color: ${ Color.main };
		border-radius: 30px;
		margin: 32px 0;
	}
	.hero-paragraph__subtitle {
		${ Montserrat(18, 500, Color.grey) };
		margin-top: 20px;
	}
	@media ${Device.lg} {
		.hero-paragraph__title { 
			font-size: 46px;
			line-height: 46px;
		}
	}
`
/*----- Export -----*/
const HeroParagraph = ({ title, subtitle }) => (
  <StyledInsuranceItem className="hero-paragraph">
		<div className="hero-paragraph__text-container">
			<h2 className="hero-paragraph__title">
				{ title }
			</h2>
			<div className="hero-paragraph__border"></div>
			<p className="hero-paragraph__subtitle">
				{ subtitle }
			</p>
		</div>
  </StyledInsuranceItem>
)
export default HeroParagraph

/*----- PropTypes -----*/
HeroParagraph.propTypes = {
  title:	  PropTypes.string.isRequired,
  subtitle: PropTypes.string
}
